export const DIALOG = 'f-dialog'
export const DIALOG_BASIC = 'f-dialog-basic'
export const DIALOG_CONFIRM = 'f-dialog-confirm'
